module.exports = __webpack_public_path__ + "img/ChristmasHorsies.c9d60092.svg";